module.exports = __webpack_public_path__ + "img/bg_kb_type7.46721b28.png";